import { css } from 'lit';

// Shoelace sized medium buttons from the small font size at 2.5rem tall.
export const buttonStyles = css`
  wa-button:not([size]),
  wa-button[size='m'],
  wa-button[size='medium'] {
    font-size: var(--wa-font-size-s);
    --wa-form-control-padding-block: 0.8em;
  }
  wa-button[size='l'],
  wa-button[size='large'] {
    font-size: var(--wa-font-size-m);
  }
`;

export const waStyles = [
  buttonStyles,
  css`
  wa-button.rounded-angles::part(base) {
    border-radius: 1rem 0;
  }
  wa-button.custom-button::part(base) {
    border: 1px solid var(--windows-stroke-glass-specular);
    background: var(--Windows-Glass);
    background-blend-mode: luminosity;
    backdrop-filter: blur(50px);
    color: var(--wa-color-neutral-on-normal);
  }
  wa-button.custom-button::part(base):hover,
  wa-button.custom-button::part(base):active {
    color: var(--wa-color-brand-40);
    box-shadow: 0px -0.5px 1px 0px rgba(255, 255, 255, 0.30) inset, 0px -0.5px 1px 0px rgba(255, 255, 255, 0.25) inset, 1px 1.5px 4px 0px rgba(0, 0, 0, 0.08) inset, 1px 1.5px 4px 0px rgba(0, 0, 0, 0.10) inset;
    border-color: var(--wa-color-brand-40);
  }
  wa-button.custom-button::part(base):focus {
    color: var(--wa-color-brand-40);
    border-color: var(--wa-color-brand-40);
  }

  wa-tab {
    padding-bottom: .5rem;
    font-size: var(--wa-font-size-s);
  }
  wa-tab::part(base) {
    background: var(--wa-color-brand-95);
    margin-right: .125rem;
    padding: .75rem 1rem;
  }
  wa-tab[active] wa-icon {
    fill: var(--wa-color-brand-95) !important;
  }
  wa-tab::part(base):hover,
  wa-tab:hover wa-icon {
    color: var(--wa-color-brand-95) !important;
    fill: var(--wa-color-brand-95) !important;
    background: var(--wa-color-brand-40) !important;
  }
  wa-tab[active]::part(base) {
    background: var(--wa-color-brand-40) !important;
    color: var(--wa-color-brand-95) !important;
  }
  wa-tab:focus-visible {
    --wa-focus-ring: var(--wa-focus-ring-style) var(--wa-focus-ring-width) var(--wa-color-brand-60);
  }
`,
];
